import useIsLoggedIn from "@casino/legacy/client/hooks/user/useIsLoggedIn";
import useSite from "@casino/legacy/client/hooks/useSite";
import { useSocialAuthConfQuery } from "@workspace/casino_core/queries/SocialAuthConfQuery.client";
import getConnections from "./helpers/getConnections";

const useSocialAuthConf = () => {
  const { site } = useSite();
  const isLoggedIn = useIsLoggedIn();
  const { loading, error, data } = useSocialAuthConfQuery({
    variables: { site },
    skip: isLoggedIn,
  });
  const auth0Config = data?.userManagement?.auth0Conf;
  const cognitoConfig = data?.userManagement?.cognitoConf;
  const connections = getConnections(
    site,
    auth0Config?.connections?.filter((item) => item != null) || [],
    cognitoConfig?.connections?.filter((item) => item != null) || [],
  );

  return {
    loading,
    error,
    connections,
    auth0Config,
    cognitoConfig,
  };
};

export default useSocialAuthConf;
